import {useState} from 'react';
import { Button, Table, Spin, Modal, Tag } from "antd";
import Header from "../../../components/HeaderList";
import { ReactComponent as Edit } from "../../../assets/icons/edit.svg";
import { ReactComponent as Trash } from "../../../assets/icons/trash.svg";
import { ReactComponent as Password } from "../../../assets/icons/password.svg";

import { getColumnSearchProps } from "../../../utils/tables";
import styles from "../styles/VehiclesUI.module.css";
import { PasswordEditor } from "./PasswordEditor";
import { Link } from "react-router-dom";


const VehiclesUI = (props) => {
  const {
    loading,
    vehicles,
    vehicle,
    areas,
    openEditorPassword,
    editorPasswordVisible,
    closeEditorPassword,
    changePassword,
    confirmDelete,
    pageSize
    /*
    userList,
    openEditor,
    editorVisible,    
    closeEditor,
    newVehicle,
    handleVehicle,*/
  } = props;
  const [filteredInfo, setFilteredInfo] = useState({});

  const getStatus = (status) => {
    if (status === 1) {
      return "Activo";
    }
    return "Inactivo";
  };

  const getAvailable = (status) => {
    if (status === 1) {
      return "Disponible";
    }
    if (status === 2) {
      return "En Pausa";
    }
    return "No Disponible";
  };

  const handleTableChange = (pagination, filters) => {
    setFilteredInfo(filters);
  };

  const areasList = areas.map(x => {  return {text: x.nombre, value: x.id} });

  const getAreaName = (id) => {
    const index = areasList.findIndex((el) => el.value === id);
    if (index > -1) {
      return areasList[index].text;
    }
    return "-";
  };

  const columns = [
    {
      title: "Área",
      align: "center",
      dataIndex: "id_area",
      filters: areasList,
      filterMultiple: true,
      onFilter: (value, record) => record.id_area === value,
      filteredValue: filteredInfo.id_area || null,
      render: (val) => getAreaName(val),
    },
    {
      title: "ID",
      dataIndex: "id",
      align: "center",
    },
    {
      title: "Usuario",
      dataIndex: "name",
      align: "center",
      filteredValue: filteredInfo.name || null,
      ...getColumnSearchProps("name"),
    },
    {
      title: "Placa Vehiculo",
      dataIndex: "plate",
      align: "center",
      filteredValue: filteredInfo.plate || null,
      ...getColumnSearchProps("plate"),
    },
    {
      title: "Aceptar Ordenes",
      dataIndex: "available",
      align: "center",
      filters: [
        { text: "Disponible", value: 1 },
        { text: "En Pausa", value: 2 },
        { text: "No Disponible", value: 0 },
      ],
      onFilter: (value, record) => record.available === value,
      filteredValue: filteredInfo.available || null,
      render: (val) => {
        let color = "error";
        let name = getAvailable(val);
        if(val === 1) {
          color="success";
        }
        if(val === 2) {
          color="warning";
        }

        return <Tag color={color}>{name}</Tag>
      }
    },
    {
      title: "Estado",
      dataIndex: "active",
      align: "center",
      filters: [
        { text: "Activo", value: 1 },
        { text: "Inactivo", value: 0 },
      ],
      onFilter: (value, record) => record.active === value,
      filteredValue: filteredInfo.active || null,
      render: (val) =>
        val ? (
          <Tag color="default"> {getStatus(val)} </Tag>
        ) : (
          <Tag color="error">{getStatus(val)}</Tag>
        ),
    },
    {
      title: "Acciones",
      align: "center",
      dataIndex: "id",
      render: (id, record) => (
        <div className={styles.actions}>
          <Link to={`driver/edit/${id}`}>
            <div className={styles.edit}>
              <Edit />
            </div>
          </Link>
          <div className={styles.divider} />
          <div
            className={styles.password}
            onClick={() => openEditorPassword(record)}
          >
            <Password />
          </div>
          <div className={styles.divider} />

          <div className={styles.delete} onClick={() => confirmDelete(id)}>
            <Trash />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header
        back="/ajustes"
        title="Listado de drivers"
        actions={
          <div className={styles.buttons}>
            <Link to={"pausas"}>
              <Button type="primary" size="middle" >
                DRIVERS EN PAUSA
              </Button>
            </Link>
            <Link to={`driver/new`}>
              <Button type="primary" size="middle" >
                AGREGAR DRIVER
              </Button>
            </Link>
          </div>
        }
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <Table rowKey="id" columns={columns} dataSource={vehicles} onChange={handleTableChange} pagination={{ pageSize: pageSize }} />
        </div>
      )}
      <Modal
        destroyOnClose
        closable={false}
        visible={editorPasswordVisible}
        footer={false}
        onCancel={closeEditorPassword}
        width={400}
      >
        <PasswordEditor close={closeEditorPassword} changePassword={changePassword} vehicle={vehicle} />
      </Modal>
      {/* 
      <Modal
        destroyOnClose
        closable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={600}
      >
        <Editor
          close={closeEditor}
          vehicle={vehicle}
          branches={branches}
          userList={userList}
          handleVehicle={handleVehicle}
        />
      </Modal>
      */}
    </div>
  );
};

export default VehiclesUI;
